import React from "react";
import { Lesson, Play } from "./icons";

/**
 * The other lessons in this module, as a strip under the stage.
 *
 * These used to be photo-fronted cards sized to a fifth of the viewport, which
 * meant a module of ten lessons became a scroll hunt. They're now compact rows
 * — glyph, title, description — so the whole module is visible at once and the
 * current lesson is obvious.
 */
export const PPTTiles = ({ pptTiles, onItemClick, selectedItem }) => {
  const items = pptTiles?.items || [];
  if (items.length <= 1) return null;

  return (
    <div style={{ padding: "var(--s-5)", borderTop: "1px solid var(--border-subtle)" }}>
      <p className="ds-eyebrow" style={{ marginBottom: "var(--s-3)" }}>
        Lessons in {pptTiles?.categoryName || "this module"}
      </p>

      <div className="ds-grid ds-grid--3">
        {items.map((item, index) => {
          const isActive = selectedItem === index;
          return (
            <button
              key={item._id || index}
              type="button"
              onClick={() => onItemClick(item, index)}
              className={`ds-card ds-card--interactive${isActive ? " ds-card--accent" : ""}`}
              style={{
                display: "flex",
                gap: "var(--s-3)",
                alignItems: "flex-start",
                textAlign: "left",
                padding: "var(--s-4)",
                cursor: "pointer",
                font: "inherit",
                background: isActive ? "var(--brand-50)" : "var(--surface)",
                borderColor: isActive ? "var(--brand-100)" : "var(--border)",
              }}
            >
              <span
                className="ds-tile"
                style={{
                  width: 30,
                  height: 30,
                  background: isActive ? "var(--brand-600)" : "var(--surface-sunken)",
                  color: isActive ? "#fff" : "var(--ink-3)",
                }}
              >
                {isActive ? <Play size={13} /> : <Lesson size={15} />}
              </span>

              <span style={{ minWidth: 0 }}>
                <span
                  className="ds-h3"
                  style={{
                    display: "block",
                    fontSize: 13,
                    color: isActive ? "var(--brand-700)" : "var(--ink)",
                  }}
                >
                  {item.title}
                </span>
                {item.description && (
                  <span
                    className="ds-sub"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      marginTop: 3,
                    }}
                  >
                    {item.description}
                  </span>
                )}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PPTTiles;
